<section class="container pb-6 pl-2 pt-2">
  <app-menu/>
</section>
@if (idleTimeoutService.secondsRemaining(); as seconds) {
  <div class="notification is-warning container" role="alertdialog" aria-live="assertive" id="session-idle-warning">
    <span>{{ ('session.idle.warning.message' | localize).replace('{seconds}', '' + seconds) }}</span>
    <button class="button is-dark is-small ml-3" (click)="idleTimeoutService.stayLoggedIn()">
      {{ 'button.session.stay.label' | localize }}
    </button>
  </div>
}
<main class="container pb-6 pl-2">
  <router-outlet/>
</main>
